import React, { FC, FunctionComponent, SVGProps } from "react";
import "../../../styles/homePage/table/table.scss";
import TableFilters, { TableFiltersProps } from "./TableFilters";
import TableRow from "./TableRow";
import SortTable, { SortTableProps } from "./SortTable";
import { TableRowProps } from "@mui/material";
import { DateRange } from "react-day-picker";

export interface TableProps<T> {
  tableData: T[];
  rowClick?: (index: number) => void; // Add rowClick prop here
  EndRowIcon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  DeleteRowIcon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  deleteClick?: (index: number) => void;
  dateFilter?: {
    selectedRange: DateRange | undefined;
    setSelectedRange: (val: DateRange | undefined) => void;
  };
  searchAutoFocus?: boolean;
}

const Table = <T extends object>({
  tableHeadline,
  trashAction,
  setFilters,
  filters,
  searchValue,
  setSearchValue,
  searchPlaceholder,
  buttonText,
  buttonAction,
  subButtonText,
  subAction,
  tableData,
  setSortKey,
  sortKey,
  sortKeysArray,
  sortOrder,
  setSortOrder,
  filterObj,
  rowClick,
  EndRowIcon,
  dateFilter,
  toggleRowSelection,
  toggleSelectAll,
  allSelected = false,
  showCheckbox = true,
  selectedRows,
  DeleteRowIcon,
  searchAutoFocus,

  deleteClick,
}: TableProps<T> &
  TableFiltersProps &
  Partial<SortTableProps> &
  TableRowProps & {
    toggleRowSelection?: (index: number) => void;
    toggleSelectAll?: () => void;
    allSelected?: boolean;
    showCheckbox?: boolean;
    selectedRows?: string[];
  }) => {
  return (
    <div className="table-main-container">
      {/* {filterObj && Object.keys(filterObj).length > 0 && ( */}
      <div className="filters-container">
        <TableFilters
          autoFocus={searchAutoFocus}
          dateFilter={dateFilter}
          filterObj={filterObj}
          tableHeadline={tableHeadline}
          trashAction={trashAction}
          setFilters={setFilters}
          filters={filters}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          searchPlaceholder={searchPlaceholder}
          buttonText={buttonText}
          buttonAction={buttonAction}
          subButtonText={subButtonText}
          subAction={subAction}
        />
      </div>
      {/* )} */}
      <div className="sort-wrapper">
        <div className="sort-header-row">
          {/* {showCheckbox && (
            <div className="cell checkbox-cell">
              <input
                type="checkbox"
                checked={allSelected}
                onChange={toggleSelectAll}
              />
            </div>
          )} */}
          <SortTable
            setSortOrder={setSortOrder!}
            sortOrder={sortOrder!}
            // keys={Object.keys(tableData[0]).map(value => { return { name: value, val: value } })}
            sortKeysArray={sortKeysArray!}
            setSortKey={setSortKey!}
            sortKey={sortKey!}
            extraRowIcon={Boolean(EndRowIcon)}
            allSelected={allSelected}
            toggleSelectAll={toggleSelectAll}
            showCheckbox={showCheckbox}
          />
        </div>
      </div>
      <div className="table-wrapper">
        {tableData.map((row, index) => {
          const isUnassigned =
            (row as any).status === "Unassigned" &&
            !(row as any).lastSync &&
            (row as any).hardwareVersionId === "Unknown" &&
            (row as any).firmwareVersionId === "Unknown";
          return (
            <TableRow
              key={index}
              row={row}
              index={index}
              rowClick={rowClick}
              EndRowIcon={EndRowIcon}
              deleteClick={
                isUnassigned ? () => deleteClick?.(index) : undefined
              }
              DeleteRowIcon={DeleteRowIcon}
              showCheckbox={showCheckbox}
              isChecked={selectedRows?.includes(index.toString())}
              onToggleCheckbox={() => toggleRowSelection?.(index)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Table;
